<template>
  <div id="data-list-groups" class="data-list-container">
    <vs-table ref="table" responsive pagination :max-items="itemsPerPage" search :data="originList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2">{{ minItemsPerPage }} - {{ currentItemsPerPage }} of {{ queriedItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">{{ $t(`GROUPVIEW.name`) }}</vs-th>
        <vs-th sort-key="description">{{ $t(`GROUPVIEW.description`) }}</vs-th>
        <vs-th sort-key="companyName">{{ $t(`GROUPVIEW.company`) }}</vs-th>
        <vs-th sort-key="status">{{ $t(`GROUPVIEW.state`) }}</vs-th>
        <vs-th>{{ $t(`GROUPVIEW.actions`) }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.companyName }}</p>
            </vs-td>

            <vs-td>
              {{ tr.status | TranslateStatus }}
              <!-- <vs-progress :percent="100" :color="tr.status | getPopularityColor" class="shadow-md" /> -->
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                class="ml-2"
                icon="InfoIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="infoData(tr)"
              />

              <feather-icon
                v-if="checkCrud(rol, 'delete')"
                class="ml-2"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="deleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import * as Groups from "./Groups";
import { notify } from "@/helpers/$vs.js";
import { _Permissions } from "../../acl/permitions";

export default {
  mixins: [_Permissions],
  data() {
    return {
      activeForm: {},
      activePrompt: false,
      selectedFormVersion: 1,

      activePopup: false,
      listGroups: [],

      recordId: null,
      originList: [],
      itemsPerPage: 7,
      isMounted: false
    };
  },
  computed: {
    rol() {
      return this.$store.state.user.roleName;
    },
    currentPage() {
      if (this.isMounted) {
        // return this.$refs.table.currentx;
        return true;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.originList.length;
    },
    minItemsPerPage() {
      return this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    currentItemsPerPage() {
      return this.originList.length - this.currentPage * this.itemsPerPage > 0
        ? this.currentPage * this.itemsPerPage
        : this.originList.length;
    }
  },
  filters: {
    TranslateStatus(status) {
      const translate = status === "Active" ? "Activo" : "Inactivo";
      return translate;
    },
    getPopularityColor(status) {
      switch (status) {
        case "Active":
          return "primary";
          break;
        case "Inactive":
          return "warning";
          break;
        case "Blocked":
          return "danger";
          break;
        case "Banned":
          return "danger";
          break;
        case "Deleted":
          return "danger";
          break;
        default:
          return "warning";
          break;
      }
    }
  },
  methods: {
    async getAllGroups() {
      this.$vs.loading({ type: "sound" });

      try {
        const result = await Groups.getAllGroups();
        this.originList = result;
      } catch (error) {
        const message = error.error ? error.error : `(${error.message})`;
        let text = "";

        if (message === "Groups are empty") text = `No hay grupos registrados.`;

        notify("Grupos", text, "warning");
      } finally {
        this.$vs.loading.close();
      }
    },

    deleteData(data) {
      this.recordId = data.key;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t(`GROUPVIEW.DIALOGS.titleDelete`, { description: data.description }),
        text: this.$t(`GROUPVIEW.DIALOGS.textDelete`),
        acceptText: this.$t(`GROUPVIEW.acept`),
        cancelText: this.$t(`GROUPVIEW.cancel`),
        accept: () => this.deleteOriginItem(this.recordId)
      });
    },

    async deleteOriginItem(idGroup) {
      this.$vs.loading({ type: "sound" });
      try {
        await Groups.deleteGroup(idGroup);
        await this.getAllGroups();
      } catch (error) {
        console.log("deleteOriginItem Error:", error);

        if (error.status === 718 && error.message === "You are not authorized to access the requested resource.") {
          return this.$vs.notify({
            title: this.$t(`GROUPVIEW.NOTIFY.titleDeleteGorup`),
            text: this.$t(`GROUPVIEW.NOTIFY.NotAutorization`),
            color: "warning",
            icon: "error",
            time: 6000
          });
        }

        this.$vs.notify({
          title: this.$t(`GROUPVIEW.NOTIFY.titleDeleteGorup`),
          text: this.$t(`GROUPVIEW.NOTIFY.error`),
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.recordId = null;
        this.$vs.loading.close();
      }
    },

    infoData(data) {
      this.$vs.notify({
        title: this.$t(`GROUPVIEW.NOTIFY.goups`),
        text: this.$t(`GROUPVIEW.NOTIFY.ActionUnavaliable`),
        color: "warning",
        icon: "error",
        time: 4500
      });
    }
  },
  mounted() {
    this.isMounted = true;
    this.getAllGroups();
  }
};
</script>

<style lang="scss">
#data-list-groups {
  @import "@/assets/css/_themeTable.scss";
}
</style>
